import React, { useState, useEffect } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import GetYourQuote from '../../GetYourQuote';

import * as S from './ColumnNavBar.styles';
import { SunheroMotto } from './NavHeader/NavHeader.styles';
import NavHeader from './NavHeader';
import NavMenu from '../NavMenu';
import { SplitRow } from '../SeoNavBar.styles';

import useWindowSize from '../../../hooks/useWindowSize';

const ColumnNavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();
  const { t } = useTranslation(['navigation']);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  return (
    <S.ColumnWrapper isOpen={isOpen}>
      <NavHeader isOpen={isOpen} setIsOpen={setIsOpen} />
      <S.Divider isOpen={isOpen} />
      {width <= 500 && (
        <>
          <NavMenu />
          {isOpen && <GetYourQuote isOnNavbar styles="getYourQuoteYellow" />}
        </>
      )}
      {width < 1280 && width > 500 && (
        <SplitRow>
          <div>
            <SunheroMotto
              data-testid="sunheroMottoTablet"
              id="sunheroMotto"
              isOpen={isOpen}
            >
              {t('motto')}
            </SunheroMotto>
            {isOpen && <GetYourQuote isOnNavbar styles="getYourQuoteYellow" />}
          </div>
          <NavMenu />
        </SplitRow>
      )}
    </S.ColumnWrapper>
  );
};

export default ColumnNavBar;
